/*
 * @Author: bbqin
 * @Date: 2022-10-19 16:28:18
 * @LastEditTime: 2023-09-07 13:50:00
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\MetaFieldSetting\setting\adapter\formCard\view.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component } from "react";
import { Row, Input, Tooltip } from "@platform/base";
import { isJSON } from "@platform/api";
import Dnd from '../../libs/dnd';
import { match } from '../../libs/utils';
import classnames from 'classnames';
import FormCard from '../../../../Form/components/container/FormCard';
import { getSysFieldid } from '@platform/api';

const { cardSizeMap } = FormCard;

/**
 * 左侧的属性面板
 */
class View extends Component {
    constructor(props) {
        super(props);
    }

    onSearch = (value, e) => {
        const { store, code } = this.props;
        const viewStore = store.getStore(['formCardData', code, 'view']) || {};
        const { data = [] } = viewStore;

        const nextData = data.map(item => {
            const { $id, props = {} } = item;
            const { title } = props;
            // 是否是过滤的
            item.filtered = match(title, value);
            return item;
        });

        store.setStore(['formCardData', code, 'view', 'value'], value, false);
        store.setStore(['formCardData', code, 'view', 'data'], nextData, true);

        // TODO search
        // scrollIntoView 聚焦到首项
    }

    onDragEnd = data => {
        const { store, code } = this.props;
        // TODO 设置数据
        store.setStore(['formCardData', code, 'view', 'data'], data, false);
    }

    render() {

        const { store, code, pageScope } = this.props;
        const langJson = store.getStore('langJson');
        const viewStore = store.getStore(['formCardData', code, 'view']) || {};
        let { value, data = [] } = viewStore;
        // 处理下数据
        data = data.map(item => {
            const { $id, attrcode, props = {} } = item;
            const { size = 'md' } = props;
            let span = cardSizeMap[size] || ('' + size);

            // const className = span ? ' view-item-col view-item-col-' + span : ' view-item-col view-item-col-16 ';
            const className = ' view-item-col ' ;

            return { attrcode: attrcode || $id, islock: false, ...item, className };
        });

        // 获取表单关联关系
        const cardIds = data.map(item => {
            return item?.props.moduleId;
        });
        const formRelation = store.getFormIdByCard(cardIds);

        return <div
            className="view-wrapper"
            fieldid={getSysFieldid('right_area')}
        >
            <div className="view-search">
                <span className="view-search-label">{langJson['view-list-title'] || '已添加'}</span>
                <Input
                    className="view-search-input"
                    placeholder={langJson['setting-search-placeholder'] || '请搜索'}
                    type="search"
                    value={value}
                    onChange={this.onSearch}
                    // onSearch
                    showClose
                />
            </div>
            <div className="view-list">
                <Dnd
                    data={data}
                    onDragEnd={this.onDragEnd}
                    getListItem={(item, i) => {
                        const { $id } = item;
                        return <ListItem key={$id} areaCode={code} store={store} {...item} formRelation={formRelation} pageScope={pageScope} />;
                    }}
                />
                {/* <Row grid={12} >
                    {data.map(item => {
                        const {
                            props = {},
                            $id,
                        } = item;

                        const {
                            // TODO 多语
                            title,
                            visible,
                            moduleId,
                        } = props;

                        const meta = store.getMeta() || {};
                        const layout = isJSON(meta.layout) ? JSON.parse(meta.layout) : [];
                        const pageId = meta.pageid;
                        const formId = formRelation[moduleId] || formRelation._default;
                        const formStore = (pageScope.formDataSource || {})[formId];

                        return <FormCard key={$id} store={formStore} layout={layout} meta={meta} pageId={pageId} pageScope={pageScope} {...props}></FormCard>;
                    })}
                </Row> */}
            </div>
        </div>;
    }
}

const getIconClass = (fontName, another) => {
    return `icon iconfont icon-${fontName} ${another}`;
};

class ListItem extends Component {
    constructor(props) {
        super(props);
    }

    // 右侧点击删除 不删除数据，改变数据的
    onTransferToSource = e => {
        const { store, areaCode, $id } = this.props;
        let nextFieldSourceItem = null;
        {
            // 右边移除一个
            const viewStore = store.getStore(['formCardData', areaCode, 'view']) || {};
            const { value, data = [] } = viewStore;
            const nextData = data.filter(item => {
                const { $id: current$id, props = {} } = item;
                const { title } = props;
                if (current$id === $id) {
                    // 记录数据
                    nextFieldSourceItem = item;
                    return false;
                } else {
                    // 是否是过滤的
                    item.filtered = match(title, value);
                    return true;
                }
            });
            store.setStore(['formCardData', areaCode, 'view', 'data'], nextData, false);
        }
        {
            // 左边添加一个
            const fieldStore = store.getStore(['formCardData', areaCode, 'field']) || {};
            const { value, data = [] } = fieldStore;

            // 修改显隐性
            nextFieldSourceItem.props.visible = false;

            let nextData = nextFieldSourceItem ? [...data, nextFieldSourceItem] : data;

            nextData = nextData.map(item => {
                const { props = {}, $id } = item;
                const { title } = props;
                // 是否是过滤的
                item.filtered = match(title, value);
                return item;
            });
            store.setStore(['formCardData', areaCode, 'field', 'data'], nextData, true);
        }
    };

    render() {
        const {
            store,
            filtered,
            props = {},
            $id,
            pageScope,
            formRelation = {},
        } = this.props;

        const {
            // TODO 多语
            title,
            visible,
            moduleId,
        } = props;

        const langJson = store.getStore('langJson');
        const uncontrolledVisible = store.getStore(['config', 'uncontrolledVisible']);

        const meta = store.getMeta() || {};
        const layout = isJSON(meta.layout) ? JSON.parse(meta.layout) : [];
        const pageId = meta.pageid;
        const formId = formRelation[moduleId] || formRelation._default;
        const formStore = (pageScope.formDataSource || {})[formId];

        return <div className="view-item">
            <div
                className={classnames({
                    'view-item-filtered': filtered,
                    'view-item-content': true,
                })}
            >
                {/* {required && <span className="unselected-mark iconfont icon-xinghao"></span>} */}
                <span className="view-icon" onClick={this.onTransferToSource}>
                    <Tooltip
                        placement="top"
                        overlay={langJson['action-icon-delete']}
                        delayHide={1}
                        delayShow={1000}
                    >
                        <i
                            className={getIconClass('shenpibohui', 'moveToRight')}
                        />
                    </Tooltip>
                </span>
                <FormCard store={formStore} layout={layout} meta={meta} pageId={pageId} pageScope={pageScope} {...props} useCol={false} forceHideLink={true} ></FormCard>
            </div>
        </div>;
    }
}

export default View;